module.exports = __webpack_public_path__ + "static/media/image_11.894123c9.png";